import client from './client';

/**
 * 실시간 광고송출 리스트
 */
export const advrtsLiveList = (param) =>
  client.get(`/api/manage/transmit/live`, param);

/**
 * 실시간 광고송출 리스트 개수
 */
export const advrtsLiveListCount = (param) =>
  client.get(`/api/manage/transmit/live/count`, { params: param });

/**
 * 실시간 광고송출 키워드 리스트
 */
export const advrtsLiveKeywordList = (param) =>
  client.get(`/api/manage/transmit/live/keywordList`, { params: param });

/**
 * 광고주 셋팅현황
 */
export const adverSetting = (param) =>
  client.get(`/api/manage/transmit/adver/setting`, param);

/**
 * 캠페인 셋팅현황
 */
export const campaignSettingList = (param) =>
  client.get(`/api/manage/transmit/campaign`, param);
